import { isNotDefined } from '@sgme/fp';

import type { StartAppListening } from '@/store/listenerMiddleware.ts';
import { targetAccumulatorApi } from '@/store/targetAccumulator/api/index.ts';
import { selectTargetAccumulatorTile } from '@/store/targetAccumulator/selectors.ts';
import { duplicateTile } from '@/store/tiles/slice.ts';

export const registerDuplicateTargetAccumulatorTradeCaptureListeners = (startAppListening: StartAppListening) => {
  startAppListening({
    actionCreator: duplicateTile,
    effect: async (action, api) => {
      const state = api.getState();

      const sourceTile = selectTargetAccumulatorTile(state, action.payload.sourceTileId);

      if (isNotDefined(sourceTile)) {
        return;
      }

      api.dispatch(
        targetAccumulatorApi.endpoints.checkTargetAccumulator.initiate({
          ...sourceTile,
          properties: {
            ...sourceTile.properties,
            rfs: { status: 'CANCELLED' },
          },
          tileId: action.payload.newTileId,
        }),
      );
    },
  });
};
